export function formatSnakeCaseToSpaces(text) {
  return text && text.replace(/_/g, ' ');
}
